"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initMocks = void 0;
var axios_mock_adapter_1 = __importDefault(require("axios-mock-adapter"));
var routes_1 = require("../wallet/routes");
var agreements_1 = require("./agreements");
var identity_1 = require("./identity");
var orchestration_identity_1 = require("./orchestration-identity");
var risk_1 = require("./risk");
var wallet_1 = require("./wallet");
var user_account_1 = require("./user-account");
var mock_1 = require("@genoa/mock");
var v1_routes_1 = require("../orchestration/v1-routes");
var v2_routes_1 = require("../orchestration/v2-routes");
var orchestration_get_status_1 = require("./orchestration-get-status");
var orchestration_1 = require("./orchestration");
var routes_2 = require("../user-account/routes");
// because these routes use params we can't just do `createCustomerAccountRegex(".*") like we do in other places
var createCustomerAccountRegex = /v1\/identity\/customer-accounts\/.*\/create/;
var updateCustomerAccountRegex = /v1\/identity\/customer-accounts\/.*\/update/;
// Orchestration RegEx
var setupCardRegex = /v1\/orchestration\/.*\/card\/setup?.*/;
var addCardRegex = /v1\/orchestration\/.*\/card?.*/;
var getStatusRegex = /v1\/orchestration\/status\/.*\/.*/;
var useDdaRegex = /v1\/orchestration\/.*\/.*\/dda?.*/;
var useVirtualCardRegex = /v1\/orchestration\/.*\/.*\/vc?.*/;
var useCancelPaymentRegex = /v1\/orchestration\/.*\/.*\/.*\/cancel/;
var useUnpauseBillerAccountRegex = /v1\/orchestration\/status\/product-state\/.*\/unpause?.*/;
var outstandingBalanceRegex = /v1\/orchestration\/payment\/.*\/balance?.*/;
var propertySearchRegex = /v1\/orchestration\/properties\/search?.*/;
var retryDownpaymentRegex = /v1\/orchestration\/.*\/.*\/auth/;
var billerPropertyUnitsRegex = /v1\/orchestration\/properties\/.*\/units/;
var billerPropertyPortalDetailsRegex = /v1\/orchestration\/properties\/.*\/portal/;
var billerPropertyDetailsRegex = /v1\/orchestration\/properties\/.*/;
var onboardingStatusRegex = /v1\/orchestration\/.*\/onboarding\/status?.*/;
var locationSuggestRegex = /v1\/orchestration\/location\/suggest\?address=.*/;
var findUserAccountRegex = /v1\/user-account\/find?.*/;
var updateEmailRegex = /v1\/orchestration\/.*\/account\/email/;
var rentReportingOptInRegex = /v1\/orchestration\/.*\/account\/rent-reporting\/opt-in/;
var switchSelfPayVCRegex = /v2\/orchestration\/.*\/bill\/start_selfpay/;
var switchSelfPayVCRegexV2 = /v2\/orchestration\/.*\/bill\/switch-selfpay\?bill_transaction_id=.*/;
var getDdaDecisionsRegex = /v2\/orchestration\/.*\/bill\/dda-decisions\?bill_transaction_id=.*&query_date=.*/;
var agreementsRegex = /v2\/orchestration\/.*\/agreements/;
var mock;
var evaluateOutstandingBalanceDQStates = [
    mock_1.AppMockStates.CANCELED_DQ.toString(),
    mock_1.AppMockStates.SUSPENDED_DQ_FAILED.toString(),
    mock_1.AppMockStates.SUSPENDED_DQ.toString(),
    mock_1.AppMockStates.PAUSED_DQ.toString(),
    mock_1.AppMockStates.ACTIVE_ROLLOVER_PROGRAM.toString(),
];
var onboardingStates = [
    mock_1.AppMockStates.ONBOARDING.toString(),
    mock_1.AppMockStates.CREDIT_BUILDER_ONBOARDING.toString(),
    mock_1.AppMockStates.RESUME_ONBOARDING_CREDIT_BUILDER.toString(),
    mock_1.AppMockStates.RESUME_ONBOARDING.toString(),
    mock_1.AppMockStates.RESUME_ONBOARDING_EPISODIC.toString(),
    mock_1.AppMockStates.CREDIT_CARD_ONBOARDING.toString(),
    mock_1.AppMockStates.DUPLICATE_SSN.toString(),
    mock_1.AppMockStates.MLA_ONBOARDING.toString(),
    mock_1.AppMockStates.SLC_ENABLED.toString(),
    mock_1.AppMockStates.SLC_SIMPLIFIED_PAYMENTS_ENABLED.toString(),
    mock_1.AppMockStates.SETUP_CARD_GENERIC_FAILURE_ONBOARDING.toString(),
    mock_1.AppMockStates.SETUP_CARD_V2_CARD_LINKAGE_FAIL_ONBOARDING.toString(),
    mock_1.AppMockStates.SETUP_CARD_CAPITAL_ONE_FAILURE_ONBOARDING.toString(),
    mock_1.AppMockStates.CREDIT_BUILDER_ENABLED.toString(),
    mock_1.AppMockStates.EMBED_ONBOARDING.toString(),
    mock_1.AppMockStates.SLC_CLASSIC_FLEX_ANYWHERE_ONBOARDING.toString(),
    mock_1.AppMockStates.INCOME_VERIFICATION_ONBOARDING.toString(),
    mock_1.AppMockStates.DOCUMENT_VERIFICATION_ONBOARDING.toString(),
];
var mlaStates = [mock_1.AppMockStates.MLA_ONBOARDING.toString(), mock_1.AppMockStates.MLA_IN_APP.toString()];
var blockSwitchToDebitStates = [
    mock_1.AppMockStates.BLOCK_SWITCH_TO_DEBIT_CANCEL_AUTH.toString(),
    mock_1.AppMockStates.BLOCK_SWITCH_TO_DEBIT.toString(),
];
var pendingAgreementStates = [
    mock_1.AppMockStates.IN_APP_REQUIRED_AGREEMENT_PENDING.toString(),
    mock_1.AppMockStates.USER_WALLET_INELIGIBLE.toString(),
];
var slcFlexClassicStates = [
    mock_1.AppMockStates.SLC_FLEX_CLASSIC_GET_READY.toString(),
    mock_1.AppMockStates.SLC_FLEX_CLASSIC_RENT_PAYMENT_PROCESSING.toString(),
    mock_1.AppMockStates.SLC_FLEX_CLASSIC_COVERED.toString(),
    mock_1.AppMockStates.SLC_INSUFFICIENT_FUNDS.toString(),
    mock_1.AppMockStates.SLC_GENERIC_PAYMENT_FAILURE.toString(),
    mock_1.AppMockStates.SLC_DEFAULT_PAYMENT_FAILURE.toString(),
    mock_1.AppMockStates.SLC_UPDATE_CARD.toString(),
    mock_1.AppMockStates.SLC_1ST_REPAYMENT_FAILED.toString(),
    mock_1.AppMockStates.SLC_2ND_REPAYMENT_FAILED.toString(),
    mock_1.AppMockStates.SLC_BALANCE_TOO_HIGH.toString(),
    mock_1.AppMockStates.SLC_BALANCE_TOO_LOW.toString(),
    mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_NOT_PD.toString(),
    mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_PD.toString(),
    mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYING_RENT.toString(),
    mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYMENT_SCHD.toString(),
    mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_PAYMENT_PAID.toString(),
    mock_1.AppMockStates.SLC_CLASSIC_FLEX_ANYWHERE_ONBOARDING.toString(),
];
var initMocks = function (axios, state) {
    if (mock) {
        mock.reset();
    }
    mock = new axios_mock_adapter_1["default"](axios);
    // User Account
    mock.onGet(new RegExp(findUserAccountRegex)).reply(404);
    mock.onPost(routes_2.phoneVerificationRoute).reply(201, user_account_1.postPhoneVerificationResponse);
    mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(200, user_account_1.getUserAccountResponse);
    mock.onPost(routes_2.upsertUserAccountRoute).reply(201, user_account_1.getUserAccountResponse);
    // Identity
    mock.onGet(new RegExp((0, v1_routes_1.useIdentityMatchStatusRoute)('.*'))).reply(200, orchestration_identity_1.getIdentityMatchStatusResponse);
    mock.onPost(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(201, orchestration_identity_1.postCustomerIdentityResponse);
    mock.onPut(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(201, orchestration_identity_1.putCustomerIdentityResponse);
    mock.onPut(new RegExp((0, v1_routes_1.useRestartOnboardingRoute)('.*'))).reply(204);
    mock.onPost(new RegExp((0, v1_routes_1.useRegisterActionLogRoute)('.*'))).reply(204);
    mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getOnboardingStatusResponse);
    // Risk - Orchestration
    mock.onPost(new RegExp((0, v1_routes_1.useInitiateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationInitiateOfferResponse);
    mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationEvaluateOfferResponse);
    mock.onPut(new RegExp((0, v1_routes_1.useSetOfferScheduleRoute)('.*', '*'))).reply(200, risk_1.pendingOffer);
    switch (state) {
        case mock_1.AppMockStates.EP_INSUFFICIENT_FUNDS.toString():
        case mock_1.AppMockStates.EP_DEFAULT_PAYMENT_FAILURE.toString():
        case mock_1.AppMockStates.EP_UPDATE_CARD.toString():
        case mock_1.AppMockStates.EP_GENERIC_PAYMENT_FAILURE.toString():
        case mock_1.AppMockStates.SCHEDULED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponse);
            break;
        case mock_1.AppMockStates.SCHEDULED_NEXT_MONTH.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseNextMonth);
            break;
        case mock_1.AppMockStates.TECHNICAL_ISSUE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(500);
            break;
        case mock_1.AppMockStates.TECHNICAL_ISSUE_NO_CARD.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(500);
            break;
        case mock_1.AppMockStates.RENT_PROCESSING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRentProcessing);
            break;
        case mock_1.AppMockStates.FIRST_PAYMENT_PROCESSING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFirstPaymentProcessing);
            break;
        case mock_1.AppMockStates.SECOND_PAYMENT_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSecondPaymentFailed);
            break;
        case mock_1.AppMockStates.THIRD_PAYMENT_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseThirdPaymentFailed);
            break;
        case mock_1.AppMockStates.SUSPENDED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSuspended);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.SUSPENDED_DQ.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSuspended);
            mock.onGet(new RegExp(outstandingBalanceRegex)).reply(200, orchestration_1.evaluateOutstandingBalanceDQResponse);
            mock.onPost(new RegExp(outstandingBalanceRegex)).reply(201);
            break;
        case mock_1.AppMockStates.PAUSED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePaused);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.DISPUTE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseDisputed);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.BLOCKED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseBlocked);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.REVOKED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRevoked);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.IV_SUSPENSION.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseIvPending);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.UNPAUSE_AUTOPAY_FAILURE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePaused);
            mock.onPut(new RegExp((0, v1_routes_1.unpauseAutopayRoute)('.*', '.*'))).reply(422, orchestration_1.unpauseBillerAccountResponseFailed);
            break;
        case mock_1.AppMockStates.CREDIT_BUILDER_CANCELED_USER.toString():
        case mock_1.AppMockStates.CANCELED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCanceled);
            break;
        case mock_1.AppMockStates.CANCELED_2ND_PAYMENT_UNPAID.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCanceled2ndPaymentNotPaid);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.RESUME_ONBOARDING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getResumeOnboardingStatusResponse);
            break;
        case mock_1.AppMockStates.SLC_CLASSIC_ENABLED.toString():
        case mock_1.AppMockStates.SLC_ENABLED.toString():
        case mock_1.AppMockStates.SLC_CLASSIC_FLEX_ANYWHERE_ONBOARDING.toString():
        case mock_1.AppMockStates.SLC_SIMPLIFIED_PAYMENTS_ENABLED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.pendingOfferSLC);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getResumeOnboardingStatusResponse);
            mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationEvaluateSLCOfferResponse);
            mock.onPut(new RegExp((0, v1_routes_1.useSetOfferScheduleRoute)('.*', '*'))).reply(200, risk_1.pendingOfferSLC);
            break;
        case mock_1.AppMockStates.RESUME_ONBOARDING_EPISODIC.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getResumeOnboardingEpisodicStatusResponse);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_ONBOARDING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getResumeOnboardingFAStatusResponse);
            mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationEvaluateOfferResponse);
            mock.onPut(new RegExp((0, v1_routes_1.useSetOfferScheduleRoute)('.*', '*'))).reply(200, risk_1.initiatedOffer);
            break;
        case mock_1.AppMockStates.SETUP_CARD_V2_CARD_LINKAGE_FAIL_ONBOARDING.toString():
        case mock_1.AppMockStates.SETUP_CARD_CAPITAL_ONE_FAILURE_ONBOARDING.toString():
        case mock_1.AppMockStates.SETUP_CARD_GENERIC_FAILURE_ONBOARDING.toString():
        case mock_1.AppMockStates.ONBOARDING.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(200, orchestration_identity_1.getOnboardingCustomerIdentityResponse);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            break;
        case mock_1.AppMockStates.CREDIT_BUILDER_ONBOARDING.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(200, orchestration_identity_1.getOnboardingCustomerIdentityResponse);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationEvaluateCreditBuilderOfferResponse);
            mock.onGet(new RegExp((0, v2_routes_1.getCardsV2Route)('.*'))).reply(200, { ok: true, data: __assign({}, orchestration_1.getCardsV2New) });
            break;
        case mock_1.AppMockStates.RESUME_ONBOARDING_CREDIT_BUILDER.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(200, user_account_1.getUserAccountResponse);
            mock.onGet(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(200, orchestration_identity_1.getOnboardingCustomerIdentityResponse);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationEvaluateCreditBuilderOfferResponse);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getCreditBuilderResumeOnboardingStatusResponse);
            break;
        case mock_1.AppMockStates.INCOME_VERIFICATION_ONBOARDING.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(200, orchestration_identity_1.getOnboardingCustomerIdentityResponse);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock
                .onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*')))
                .reply(201, orchestration_1.orchestrationEvaluateIncomeVerificationOfferResponse);
            mock.onGet(new RegExp((0, v2_routes_1.getCardsV2Route)('.*'))).reply(200, { ok: true, data: __assign({}, orchestration_1.getCardsV2New) });
            break;
        case mock_1.AppMockStates.DOCUMENT_VERIFICATION_ONBOARDING.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(200, orchestration_identity_1.getOnboardingCustomerIdentityResponse);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock
                .onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*')))
                .reply(201, orchestration_1.orchestrationEvaluateDocumentVerificationOfferResponse);
            break;
        case mock_1.AppMockStates.RESUME_ONBOARDING_INCOME_VERIFICATION.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getResumeOnboardingIVResponse);
            break;
        case mock_1.AppMockStates.RESUME_ONBOARDING_DOCUMENT_VERIFICATION.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onGet(new RegExp(onboardingStatusRegex)).reply(200, orchestration_1.getResumeOnboardingIVResponse);
            break;
        case mock_1.AppMockStates.DUPLICATE_SSN.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(422, orchestration_1.orchestrationEvaluateOfferDuplicateSSNResponse);
            break;
        case mock_1.AppMockStates.SLC_UPDATE_CARD.toString():
        case mock_1.AppMockStates.UPDATE_DEBIT_CARD.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseDebitCard);
            break;
        case mock_1.AppMockStates.IN_APP_DOWNPAYMENT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRetryDownpayment);
            mock.onPut(new RegExp(retryDownpaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.IN_APP_DOWNPAYMENT_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRetryDownpayment);
            mock.onPut(new RegExp(retryDownpaymentRegex)).reply(422, orchestration_1.inAppDownpaymentFailed);
            break;
        case mock_1.AppMockStates.IN_APP_DOWNPAYMENT_RATE_LIMITING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRetryDownpayment);
            mock.onPut(new RegExp(retryDownpaymentRegex)).reply(429);
            break;
        case mock_1.AppMockStates.FSLC_RELINK_SERVICE_ISSUE.toString():
        case mock_1.AppMockStates.RELINK.toString():
        case mock_1.AppMockStates.CREDIT_BUILDER_RELINK.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRelink);
            break;
        case mock_1.AppMockStates.ISSUE_MESSAGING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseIssueMessaging);
            break;
        case mock_1.AppMockStates.BALANCE_TOO_HIGH.toString():
        case mock_1.AppMockStates.BTH_CAN_OVERWRITE_HIGHER.toString():
        case mock_1.AppMockStates.BTH_CANNOT_OVERWRITE.toString():
        case mock_1.AppMockStates.BTH_CAN_OVERWRITE_EITHER.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseBalanceTooHigh);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock.onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.overwriteCreateResponse);
            mock.onPut(new RegExp((0, v1_routes_1.confirmOverwritePaymentScheduleRoute)('.*', '.*', '.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.SLC_BALANCE_TOO_HIGH.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseBalanceTooHighSLC);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock.onGet(new RegExp((0, v1_routes_1.getPricingOfferRoute)('.*'))).reply(200, orchestration_1.getPricingOfferSLCResponse);
            mock
                .onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*')))
                .reply(200, orchestration_1.overwriteCreateBTHResponseSLC);
            mock.onPut(new RegExp((0, v1_routes_1.confirmOverwritePaymentScheduleRoute)('.*', '.*', '.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.ZERO_BALANCE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseZeroBalance);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock
                .onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*')))
                .reply(200, orchestration_1.overwriteCreateResponseZeroBalance);
            mock.onPut(new RegExp((0, v1_routes_1.confirmOverwritePaymentScheduleRoute)('.*', '.*', '.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.BALANCE_TOO_LOW.toString():
        case mock_1.AppMockStates.BTL_CAN_OVERWRITE_HIGHER.toString():
        case mock_1.AppMockStates.BTL_CANNOT_OVERWRITE.toString():
        case mock_1.AppMockStates.BTL_CAN_OVERWRITE_EITHER.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseBalanceTooLow);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock
                .onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*')))
                .reply(200, orchestration_1.overwriteCreateResponseBTL);
            mock.onPut(new RegExp((0, v1_routes_1.confirmOverwritePaymentScheduleRoute)('.*', '.*', '.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.SLC_BALANCE_TOO_LOW.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseBalanceTooLowSLC);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock.onGet(new RegExp((0, v1_routes_1.getPricingOfferRoute)('.*'))).reply(200, orchestration_1.getPricingOfferSLCResponse);
            mock
                .onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*')))
                .reply(200, orchestration_1.overwriteCreateBTLResponseSLC);
            mock.onPut(new RegExp((0, v1_routes_1.confirmOverwritePaymentScheduleRoute)('.*', '.*', '.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.RELINK_INELIGIBLE.toString():
        case mock_1.AppMockStates.DDA.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseDDAFirstCall);
            mock.onPut(new RegExp(useDdaRegex)).reply(200, orchestration_1.useDdaResponse);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.SELF_PAY_VC.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseVirtualCardFirstCall);
            mock.onPut(new RegExp(useVirtualCardRegex)).reply(200, orchestration_1.useVirtualCardResponse);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.DDA_ISSUED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseDDAIssued);
            mock.onPut(new RegExp(useDdaRegex)).reply(200, orchestration_1.useDdaResponse);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            mock.onPut(new RegExp(useVirtualCardRegex)).reply(200, orchestration_1.useVirtualCardResponse);
            mock.onPost(new RegExp(switchSelfPayVCRegexV2)).reply(200);
            break;
        case mock_1.AppMockStates.VC_CANNOT_CANCEL.toString():
        case mock_1.AppMockStates.VC_ISSUED.toString():
        case mock_1.AppMockStates.VC_ISSUED_SLC.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseVirtualCardIssued);
            mock.onPut(new RegExp(useVirtualCardRegex)).reply(200, orchestration_1.useVirtualCardResponse);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.BLOCK_SWITCH_TO_DEBIT.toString():
        case mock_1.AppMockStates.BLOCK_SWITCH_TO_DEBIT_CANCEL_AUTH.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseDDAFirstCall);
            mock.onPut(new RegExp(useDdaRegex)).reply(200, orchestration_1.useDdaResponse);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            mock
                .onGet(new RegExp(getDdaDecisionsRegex))
                .reply(200, { ok: true, data: orchestration_1.useGetDdaDecisionsIneligibleResponse, error: null });
            break;
        case mock_1.AppMockStates.SELF_PAY_PENDING_AFTER_BP_CLOSE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSelfPayPending);
            break;
        case mock_1.AppMockStates.SELF_PAY_DDA_PENDING_BEFORE_BP_CLOSE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSelfPayDDAPendingBPWindowOpen);
            mock.onPut(new RegExp(useDdaRegex)).reply(200, orchestration_1.useDdaResponse);
            break;
        case mock_1.AppMockStates.SELF_PAY_VC_PENDING_BEFORE_BP_CLOSE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSelfPayVCPendingBPWindowOpen);
            break;
        case mock_1.AppMockStates.SELF_PAY_OPTED_OUT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSelfPayOptedOut);
            break;
        case mock_1.AppMockStates.NOT_COVERED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseNotCovered);
            break;
        case mock_1.AppMockStates.NOT_COVERED_USER_INITIATED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseNotCoveredUserInitiated);
            break;
        case mock_1.AppMockStates.COVERED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCoveredPaidInFull);
            break;
        case mock_1.AppMockStates.MMF_NOT_PAID.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseMMFNotPaid);
            break;
        case mock_1.AppMockStates.TWO_REPAYMENTS.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseMultipleRepayments);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock
                .onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*')))
                .reply(200, orchestration_1.overwriteCreateMultipleRepaymentsResponse);
            mock.onPut(new RegExp((0, v1_routes_1.confirmOverwritePaymentScheduleRoute)('.*', '.*', '.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.THREE_REPAYMENTS.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseThreeRepayments);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            break;
        case mock_1.AppMockStates.PAST_DUE_RENT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePastDueRent);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            break;
        case mock_1.AppMockStates.YARDI_ZERO_BALANCE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseYardiZeroBalance);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            break;
        case mock_1.AppMockStates.RESUME_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponse);
            mock.onPost(new RegExp(useUnpauseBillerAccountRegex)).reply(422, orchestration_1.unpauseBillerAccountResponseFailed);
            break;
        case mock_1.AppMockStates.BALANCE_TOO_HIGH_PAST_DUE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseBalanceTooHigh);
            mock.onGet(v1_routes_1.getRentAmountUpdateSurveyRoute).reply(200, orchestration_1.getRentAmountUpdateSurveyResponse);
            mock
                .onPost(new RegExp((0, v1_routes_1.createOverwritePaymentScheduleRoute)('.*', '.*', '.*')))
                .reply(200, orchestration_1.overwriteCreateResponsePastDue);
            break;
        case mock_1.AppMockStates.REPAY_NOW.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRepayNow);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.REPAY_NOW_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRepayNow);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(422, orchestration_1.paymentFailureExceptionResponse);
            break;
        case mock_1.AppMockStates.REPAY_NOW_MULTIPLE_REPAYMENTS.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRepayNowMultipleRepayments);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.SUSPENDED_DQ_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSuspended);
            mock.onGet(new RegExp(outstandingBalanceRegex)).reply(200, orchestration_1.evaluateOutstandingBalanceDQResponse);
            mock.onPost(new RegExp(outstandingBalanceRegex)).reply(422, orchestration_1.paymentFailureExceptionResponse);
            break;
        case mock_1.AppMockStates.CANNOT_REPAY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCannotRepayNow);
            break;
        case mock_1.AppMockStates.CREDIT_CARD_ONBOARDING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            break;
        case mock_1.AppMockStates.CREDIT_CARD_IN_APP.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCoveredPaidInFull);
            break;
        case mock_1.AppMockStates.READY_TO_PAY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseReadyToPay);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(204);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_TOO_MANY_TRIES.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseReadyToPay);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(429);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseReadyToPay);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(422);
            break;
        case mock_1.AppMockStates.SCHEDULED_OON.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledOON);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.SCHEDULED_EXISTING_OON_USER.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledExistingOONUser);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(204);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.FIRST_PAYMENT_PAID_OON.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFirstPaymentPaidOON);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.RENT_PAID_OON.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRentPaidOON);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.RENT_PAID_OON_REPAY_NOW_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRentPaidOON);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(422, orchestration_1.paymentFailureExceptionResponse);
            break;
        case mock_1.AppMockStates.RENT_PAID_OON_REPAY_NOW_429.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseRentPaidOON);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(429);
            break;
        case mock_1.AppMockStates.COVERED_OON.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCoveredOON);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_OPTED_OUT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFlexAnywhereOptedOut);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_MULTIPLE_REPAYMENTS:
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFlexAnywhereMultipleRepayments);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(422);
            break;
        case mock_1.AppMockStates.SECOND_PAYMENT_FAILED_OON.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseSecondPaymentFailedOON);
            mock.onPut(new RegExp((0, v1_routes_1.chargeRepaymentRoute)('.*', '.*'))).reply(204);
            break;
        case mock_1.AppMockStates.USED_LESS_THAN_RENT_AMT_OON.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseUsedLessThanRentAmountOON);
            break;
        case mock_1.AppMockStates.FLEX_LITE.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.getFeatureStatusRoute)('.*'))).reply(200, orchestration_1.getFeatureStatusFlexLiteResponse);
            break;
        case mock_1.AppMockStates.CANCELED_DQ.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCanceled);
            mock.onGet(new RegExp(outstandingBalanceRegex)).reply(200, orchestration_1.evaluateOutstandingBalanceDQResponse);
            mock.onPost(new RegExp(outstandingBalanceRegex)).reply(201);
            break;
        case mock_1.AppMockStates.PAUSED_DQ.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePaused);
            mock.onGet(new RegExp(outstandingBalanceRegex)).reply(200, orchestration_1.evaluateOutstandingBalanceDQResponse);
            mock.onPost(new RegExp(outstandingBalanceRegex)).reply(201);
            break;
        case mock_1.AppMockStates.MLA_IN_APP.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseMLA);
            break;
        case mock_1.AppMockStates.MLA_ONBOARDING.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            mock.onPost(new RegExp((0, v1_routes_1.useInitiateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationInitiateOfferResponse);
            mock.onPost(new RegExp((0, v1_routes_1.useEvaluateOfferRoute)('.*'))).reply(201, orchestration_1.orchestrationEvaluateOfferResponseMLA);
            mock.onPut(new RegExp((0, v1_routes_1.useSetOfferScheduleRoute)('.*', '*'))).reply(200, risk_1.pendingOffer);
            break;
        case mock_1.AppMockStates.PRE_FUND_FIRST_PAYMENT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePreFundFirstPayment);
            mock.onPost(new RegExp((0, v1_routes_1.useFundFirstPaymentRoute)('.*'))).reply(200);
            break;
        case mock_1.AppMockStates.FUNDED_FIRST_PAYMENT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFundedFirstPayment);
            break;
        case mock_1.AppMockStates.FIRST_PAYMENT_PAID.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFirstPaymentPaid);
            break;
        case mock_1.AppMockStates.CANCEL_ELIGIBILITY_ERROR.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseCoveredPaidInFull);
            mock.onPut(new RegExp((0, v1_routes_1.cancelAccountRoute)('.*', '.*'))).reply(422, orchestration_1.cancelAccountFailureResponse);
            break;
        case mock_1.AppMockStates.USER_WALLET_INELIGIBLE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePreFundFirstPayment);
            mock.onPost(new RegExp((0, v1_routes_1.useFundFirstPaymentRoute)('.*'))).reply(200);
            break;
        case mock_1.AppMockStates.ACTIVE_ROLLOVER_PROGRAM.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponse);
            mock.onGet(new RegExp(outstandingBalanceRegex)).reply(200, orchestration_1.evaluateOutstandingBalanceDQResponse);
            mock.onPost(new RegExp(outstandingBalanceRegex)).reply(201);
            break;
        case mock_1.AppMockStates.PAST_DOWNPAYMENT_DEADLINE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePastDownPaymentDeadline);
            break;
        case mock_1.AppMockStates.SLC_INSUFFICIENT_FUNDS.toString():
        case mock_1.AppMockStates.INSUFFICIENT_FUNDS.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseInsufficientFunds);
            break;
        case mock_1.AppMockStates.SLC_GENERIC_PAYMENT_FAILURE.toString():
        case mock_1.AppMockStates.GENERIC_PAYMENT_FAILURE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseGenericPaymentFailure);
            break;
        case mock_1.AppMockStates.SLC_DEFAULT_PAYMENT_FAILURE.toString():
        case mock_1.AppMockStates.DEFAULT_PAYMENT_FAILURE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseDefaultPaymentFailure);
            break;
        case mock_1.AppMockStates.FA_INSUFFICIENT_FUNDS.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledExistingOONUser);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(422, orchestration_1.flexAnywhereInsufficientFunds);
            break;
        case mock_1.AppMockStates.FA_GENERIC_PAYMENT_FAILURE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledExistingOONUser);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock
                .onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*')))
                .reply(422, orchestration_1.flexAnywhereGenericPaymentFailure);
            break;
        case mock_1.AppMockStates.FA_DEFAULT_PAYMENT_FAILURE.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledExistingOONUser);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock
                .onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*')))
                .reply(422, orchestration_1.flexAnywhereDefaultPaymentFailure);
            break;
        case mock_1.AppMockStates.FA_UPDATE_CARD.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledExistingOONUser);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(422, orchestration_1.flexAnywhereUpdateCard);
            break;
        case mock_1.AppMockStates.FA_SETTLEMENT_PENDING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResonseFlexAnywherePendingSettlement);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_ENABLED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseOonReadyToPaySlcSPEnabled);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartSlcSPEnabled);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseOonReadyToPaySlcSPDisabled);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartSlcSPDisabled);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseOonReadyToPaySlcSPDisabledMonthTwo);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartSlcSPDisabledMonthTwo);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO_ADDITIONAL_DEPOSIT.toString():
            mock
                .onGet(new RegExp(getStatusRegex))
                .reply(200, orchestration_get_status_1.getStatusResponseOonReadyToPaySlcSPDisabledMonthTwoAdditionalDeposit);
            mock
                .onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*')))
                .reply(201, orchestration_1.oonSelfPayStartSlcSPDisabledMonthTwoAdditionalDeposit);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.TWO_REPAYMENTS_OON_SLC_SP_ENABLED_MONTH_TWO.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseOonTwoRepaymentsSlcSPEnabledMonthTwo);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartSlcSPEnabled);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.TWO_REPAYMENTS_OON_SLC_SP_DISABLED_MONTH_TWO.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseOonTwoRepaymentsSlcSPDisabledMonthTwo);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartSlcSPEnabled);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_OON_SLC_SP_DISABLED_MONTH_TWO_DEPOSIT_PAID.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseOonSLCDisabledMonthTwoDepositPaid);
            mock
                .onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*')))
                .reply(201, orchestration_1.oonSelfPayStartSLCDisabledMonthTwoDepositPaid);
            mock.onGet(new RegExp((0, v1_routes_1.oonSelfPayVirtualCardRoute)('.*', '.*', '.*'))).reply(200, orchestration_1.oonSelfPayVirtualCardResponse);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_DDA_READY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledFlexAnywhereDDA);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_DDA_EXISTING_READY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseScheduledExistingFlexAnywhereDDA);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(204);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_EARLY_PAY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResonseFlexAnywhereEarlyPay);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_DDA_READY_TO_PAY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFlexAnywhereDDAReadyToPay);
            mock.onPost(new RegExp((0, v1_routes_1.oonSelfPayStartRoute)('.*', '.*', '.*'))).reply(201, orchestration_1.oonSelfPayStartResponse);
            mock.onPut(new RegExp((0, v1_routes_1.oonPayDownpaymentRoute)('.*', '.*', '.*', '.*'))).reply(204);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.FLEX_ANYWHERE_DDA_FIRST_PAYMENT_PAID.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseFlexAnywhereDDAFirstPaymentPaid);
            mock.onPut(new RegExp(useCancelPaymentRegex)).reply(204);
            break;
        case mock_1.AppMockStates.IN_APP_REQUIRED_AGREEMENT_PENDING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponse);
            break;
        case mock_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_DEP_NOT_PD.toString():
        case mock_1.AppMockStates.SLC_FLEX_CLASSIC_GET_READY.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusSLCGetReady);
            break;
        case mock_1.AppMockStates.SLC_AUTOPAY_ON_RENT_PROTECT_ON_PAYING_RENT.toString():
        case mock_1.AppMockStates.SLC_FLEX_CLASSIC_RENT_PAYMENT_PROCESSING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusSLCRentPaymentProcessing);
            break;
        case mock_1.AppMockStates.SLC_FLEX_CLASSIC_COVERED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusSLCCovered);
            break;
        case mock_1.AppMockStates.SLC_1ST_REPAYMENT_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusSLCFirstRepaymentFailed);
            break;
        case mock_1.AppMockStates.SLC_2ND_REPAYMENT_FAILED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusSLCSecondRepaymentFailed);
            break;
        case mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_NOT_PD.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusFSLCDepositNotPaid);
            break;
        case mock_1.AppMockStates.WITHDRAW_FUNDS_RENT_PAYMENT_PROCESSING.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusFSLCRentPaymentProcessing);
            break;
        case mock_1.AppMockStates.READY_TO_PAY_AUTOPILOT_DISABLED.toString():
        case mock_1.AppMockStates.READY_TO_PAY_SLC_AUTOPILOT_DISABLED.toString():
        case mock_1.AppMockStates.READY_TO_PAY_SLC_SP_OFF_AUTOPILOT_DISABLED.toString():
        case mock_1.AppMockStates.READY_TO_PAY_SLC_CLASSIC_EPISODIC.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseEpisodicReadyToPay);
            break;
        case mock_1.AppMockStates.EMBED_ONBOARDING.toString():
            mock.onGet(new RegExp((0, routes_2.useGetUserAccountRoute)('.*'))).reply(404);
            mock.onGet(new RegExp((0, v1_routes_1.useCustomerIdentityRoute)('.*'))).reply(200, orchestration_identity_1.getOnboardingCustomerIdentityResponse);
            mock.onGet(new RegExp(getStatusRegex)).reply(404);
            break;
        case mock_1.AppMockStates.EMBED_PAY.toString():
        case mock_1.AppMockStates.EMBED_PAY_SLC.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseEmbed);
            break;
        case mock_1.AppMockStates.ADDITIONAL_DEPOSIT_NEEDED.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseAdditionalPayment);
            break;
        case mock_1.AppMockStates.PORTAL_CREDENTIALS_RELINK.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePortalCredentialsInvalid);
            mock.onGet(new RegExp(billerPropertyPortalDetailsRegex)).reply(200, orchestration_1.getBillerPropertyPortalDetailsResponse);
            break;
        case mock_1.AppMockStates.PROPERTY_FEE_PASSTHROUGH.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponsePropertyFeePassthrough);
            break;
        case mock_1.AppMockStates.RESCHEDULE_PAYMENT.toString():
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponseReschedulePayment);
            break;
        default:
            mock.onGet(new RegExp(getStatusRegex)).reply(200, orchestration_get_status_1.getStatusResponse);
    }
    mock.onPost(createCustomerAccountRegex).reply(201, identity_1.createCustomerResponse);
    mock.onPut(updateCustomerAccountRegex).reply(200);
    if (state !== mock_1.AppMockStates.FLEX_LITE) {
        mock.onGet(new RegExp((0, v1_routes_1.getFeatureStatusRoute)('.*'))).reply(200, orchestration_1.getFeatureStatusResponse);
    }
    // Relink
    mock.onPut(new RegExp((0, v1_routes_1.acceptOfferRelinkRoute)('.*', '.*', '.*'))).reply(200, risk_1.acceptedOffer);
    // Risk
    mock.onPut(new RegExp((0, v1_routes_1.useAcceptOfferRoute)('.*', '.*'))).reply(200, risk_1.acceptedOffer);
    mock.onGet(new RegExp((0, v1_routes_1.getScheduleOptionsRoute)('.*', '*'))).reply(200, risk_1.getScheduleOptionsResponse);
    // Pricing - Orchestration
    if (state && mlaStates.includes(state)) {
        mock.onGet(new RegExp((0, v1_routes_1.getPricingOfferRoute)('.*'))).reply(200, orchestration_1.getPricingOfferResponseMLA);
    }
    else if (state && slcFlexClassicStates.includes(state)) {
        mock.onGet(new RegExp((0, v1_routes_1.getPricingOfferRoute)('.*'))).reply(200, orchestration_1.getPricingOfferSLCResponse);
    }
    else if (state &&
        (state === mock_1.AppMockStates.FSLC_AUTOPAY_ON_RENT_PROTECT_OFF_DEP_NOT_PD ||
            state === mock_1.AppMockStates.CREDIT_BUILDER_ONBOARDING ||
            state === mock_1.AppMockStates.CREDIT_BUILDER_REPAYMENT_FAILED)) {
        mock.onGet(new RegExp((0, v1_routes_1.getPricingOfferRoute)('.*'))).reply(200, orchestration_1.getPricingOfferFSLCResponse);
    }
    else {
        mock.onGet(new RegExp((0, v1_routes_1.getPricingOfferRoute)('.*'))).reply(200, orchestration_1.getPricingOfferResponse);
    }
    // Wallet - Orchestration
    mock.onPost(setupCardRegex).reply(201, orchestration_1.setupCardResponse);
    mock.onPost(new RegExp(addCardRegex)).reply(201, orchestration_1.addCardResponse);
    mock.onPut(setupCardRegex).reply(204);
    mock.onPost(new RegExp((0, routes_1.assignCustomerDdaRoute)('.*'))).reply(201, wallet_1.assignDdaResponse);
    if (state && blockSwitchToDebitStates.includes(state)) {
        mock
            .onGet(new RegExp(getDdaDecisionsRegex))
            .reply(200, { ok: true, data: orchestration_1.useGetDdaDecisionsIneligibleResponse, error: null });
    }
    else {
        mock.onPost(new RegExp(switchSelfPayVCRegex)).reply(200);
        mock.onGet(new RegExp(getDdaDecisionsRegex)).reply(200, { ok: true, data: orchestration_1.useGetDdaDecisionsResponse, error: null });
        mock.onPut(new RegExp(useVirtualCardRegex)).reply(200, orchestration_1.useVirtualCardResponse);
    }
    // Account State
    mock.onPost(new RegExp(updateEmailRegex)).reply(200, orchestration_identity_1.updateEmailResponse);
    // Outstanding balance
    if (state && !evaluateOutstandingBalanceDQStates.includes(state)) {
        mock.onGet(new RegExp(outstandingBalanceRegex)).reply(200, orchestration_1.evaluateOutstandingBalanceNotDQResponse);
    }
    // Update Offer Terms
    if (state !== mock_1.AppMockStates.ONBOARDING &&
        state !== mock_1.AppMockStates.RESUME_ONBOARDING &&
        state !== mock_1.AppMockStates.EMBED_ONBOARDING &&
        state !== mock_1.AppMockStates.CREDIT_BUILDER_ONBOARDING &&
        state !== mock_1.AppMockStates.INCOME_VERIFICATION_ONBOARDING &&
        state !== mock_1.AppMockStates.RESUME_ONBOARDING_INCOME_VERIFICATION &&
        state !== mock_1.AppMockStates.DOCUMENT_VERIFICATION_ONBOARDING &&
        state !== mock_1.AppMockStates.RESUME_ONBOARDING_DOCUMENT_VERIFICATION) {
        mock.onPut(new RegExp((0, v1_routes_1.updateOfferTermsRoute)('.*', '.*'))).reply(204);
    }
    // Accepted Offer for In-App
    if (state && !onboardingStates.includes(state) && !slcFlexClassicStates.includes(state)) {
        mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.acceptedOffer);
    }
    else if (state && onboardingStates.includes(state)) {
        mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.pendingOffer);
    }
    else if (state && slcFlexClassicStates.includes(state)) {
        mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.acceptedOfferFSLC);
    }
    else {
        mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.pendingOffer);
    }
    if (state && onboardingStates.includes(state) && slcFlexClassicStates.includes(state)) {
        mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.pendingOfferSLC);
    }
    if (state && state === mock_1.AppMockStates.RESUME_ONBOARDING_INCOME_VERIFICATION) {
        mock
            .onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*')))
            .reply(200, risk_1.pendingOfferVerifyIncomeIncomeVerification);
    }
    if ((state && state === mock_1.AppMockStates.DOCUMENT_VERIFICATION_ONBOARDING) ||
        state === mock_1.AppMockStates.RESUME_ONBOARDING_DOCUMENT_VERIFICATION) {
        mock.onGet(new RegExp((0, v1_routes_1.getOfferByBillerAccountRoute)('.*', '*'))).reply(200, risk_1.pendingOfferDocumentVerification);
    }
    // Property Search
    mock.onGet(new RegExp(propertySearchRegex)).reply(200, orchestration_1.propertiesSearchResponse);
    // Location Suggest
    mock.onGet(locationSuggestRegex).reply(204, orchestration_1.getLocationSuggestResponse);
    // Cancel Account (orchestration)
    if (state !== mock_1.AppMockStates.CANCEL_ELIGIBILITY_ERROR) {
        mock.onPut(new RegExp((0, v1_routes_1.cancelAccountRoute)('.*', '.*'))).reply(204, orchestration_1.cancelAccountSuccessResponse);
    }
    // Pause Autopay
    mock.onPut(new RegExp((0, v1_routes_1.pauseAutopayRoute)('.*', '.*'))).reply(204, orchestration_1.pausedAutopayResponse);
    mock.onGet(new RegExp(billerPropertyUnitsRegex)).reply(200, orchestration_1.getBillerPropertyUnitsResponse);
    mock.onGet(new RegExp(billerPropertyPortalDetailsRegex)).reply(200, orchestration_1.getBillerPropertyPortalDetailsResponse);
    if (state && mock_1.AppMockStates.FLEX_ANYWHERE_ONBOARDING === state) {
        mock.onGet(new RegExp(billerPropertyDetailsRegex)).reply(200, orchestration_1.getBillerPropertyDetailsFlexAnywhereResponse);
    }
    else {
        mock.onGet(new RegExp(billerPropertyDetailsRegex)).reply(200, orchestration_1.getBillerPropertyDetailsResponse);
    }
    // Agreements
    if (state && onboardingStates.includes(state)) {
        mock.onGet(agreementsRegex).reply(200, agreements_1.onboardingAgreementsResponse);
    }
    else if (state && pendingAgreementStates.includes(state)) {
        mock.onGet(agreementsRegex).reply(200, agreements_1.onboardedPendingAgreementsResponse);
    }
    else {
        mock.onGet(agreementsRegex).reply(200, agreements_1.onboardedAgreementsResponse);
    }
    // Rent Reporting
    mock.onGet(new RegExp(rentReportingOptInRegex)).reply(201, null);
    mock.onPost(new RegExp(rentReportingOptInRegex)).reply(200, orchestration_1.getRentReportingOptInStatus);
};
exports.initMocks = initMocks;
